<div class="label-info {{ class }}">
  <div class="label-info-title {{ titleClass }}" [innerHTML]="title" *ngIf="!noTitle"></div>
  <div class="label-info-value {{ valueClass }}" *ngIf="!value">
    <ng-content></ng-content>
  </div>
  <div class="label-info-value {{ valueClass }}" [innerHTML]="value" [title]="value | safeHtml"></div>
</div>
